var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDogUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5DCB4"
    },
    d: "M437.677,45.419h-82.581C325.161,57.29,318.525,37.161,256,37.161s-69.161,20.129-99.097,8.258 h-82.58L63.312,252.904c6.882,81.548,57.462,125.935,97.377,142.107h190.623c39.914-16.172,90.495-60.559,97.377-142.107 L437.677,45.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965A50"
    },
    d: "M355.097,45.419C448.078,73.25,397.46,216.774,457.33,278.813c8.595,8.906,23.781,4.95,27.368-6.895 c4.74-15.651,9.474-40.411,8.721-75.789C492.387,147.613,512,144.517,512,144.517S487.226,28.903,412.903,28.903 C388.129,28.903,355.097,45.419,355.097,45.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M169.29,260.129L169.29,260.129c-15.897,0-28.903-13.006-28.903-28.903v-16.516 c0-15.897,13.006-28.903,28.903-28.903l0,0c15.897,0,28.903,13.006,28.903,28.903v16.516 C198.194,247.124,185.187,260.129,169.29,260.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M169.29,185.806c-1.413,0-2.769,0.221-4.129,0.419v40.871c0,9.121,7.395,16.516,16.516,16.516 c9.122,0,16.516-7.395,16.516-16.516v-12.386C198.194,198.814,185.187,185.806,169.29,185.806z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 169.29,
    cy: 206.451,
    r: 12.387
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M342.71,260.129L342.71,260.129c-15.897,0-28.903-13.006-28.903-28.903v-16.516 c0-15.897,13.006-28.903,28.903-28.903l0,0c15.897,0,28.903,13.006,28.903,28.903v16.516 C371.613,247.124,358.606,260.129,342.71,260.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M342.71,185.806c-1.413,0-2.769,0.221-4.129,0.419v40.871c0,9.121,7.395,16.516,16.516,16.516 c9.122,0,16.516-7.395,16.516-16.516v-12.386C371.613,198.814,358.606,185.806,342.71,185.806z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 342.71,
    cy: 206.451,
    r: 12.387
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#824641"
    },
    d: "M457.33,278.814c8.595,8.906,23.781,4.95,27.368-6.896c2.718-8.976,5.399-21.06,7.08-36.313 c-16.234-8.092-30.092-33.91-38.617-77.669C437.677,78.452,416,34.065,355.097,45.419C448.078,73.25,397.46,216.775,457.33,278.814z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7C9A5"
    },
    d: "M160.689,395.011h39.141c0,0-68.732-46.107-80.087-127.656 C97.654,108.712,139.7,61.247,176.067,49.135c-5.761,0.195-11.745-0.774-19.163-3.715H74.323L63.312,252.904 C70.194,334.452,120.774,378.839,160.689,395.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965A50"
    },
    d: "M156.903,45.419C63.922,73.25,114.541,216.775,54.67,278.813c-8.595,8.906-23.781,4.95-27.368-6.895 c-4.74-15.651-9.474-40.411-8.721-75.789C19.613,147.613,0,144.517,0,144.517S24.774,28.903,99.097,28.903 C123.871,28.903,156.903,45.419,156.903,45.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#824641"
    },
    d: "M154.139,44.104c-8.38-3.888-34.516-15.201-55.042-15.201C24.774,28.903,0,144.517,0,144.517 s19.613,3.097,18.581,51.613c-0.014,0.648,0.005,1.231-0.005,1.872C66.097,17.715,139.119,37.773,154.139,44.104z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#BC8E78"
    },
    cx: 256,
    cy: 400.52,
    rx: 90.84,
    ry: 66.06
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8087"
    },
    d: "M214.71,400.516v41.29c0,22.804,18.486,41.29,41.29,41.29s41.29-18.486,41.29-41.29v-41.29H214.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6646E"
    },
    d: "M214.71,432.768c11.941-1.496,23.208-5.129,33.032-10.622v11.402c0,4.56,3.698,8.258,8.258,8.258 s8.258-3.698,8.258-8.258v-11.507c9.729,5.552,21.026,9.225,33.032,10.73v-32.256h-82.58V432.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4AF91"
    },
    d: "M309.677,326.194H202.323c-34.206,0-61.935,20.335-61.935,45.419s27.73,45.419,61.935,45.419 c17.225,0,32.782-5.169,43.995-13.498c2.839-2.108,6.262-3.162,9.679-3.162c3.423,0,6.846,1.053,9.685,3.162 c11.213,8.329,26.77,13.498,43.995,13.498c34.206,0,61.935-20.335,61.935-45.419C371.613,346.529,343.883,326.194,309.677,326.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M256,293.161c27.365,0,49.548,14.789,49.548,33.032c0,17.594-20.824,26.858-35.853,33.708 c-8.712,3.971-18.68,3.971-27.392,0c-15.029-6.85-35.853-16.114-35.853-33.708C206.452,307.951,228.635,293.161,256,293.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M230.968,317.161c-1.155-10.393,6.166-21.507,6.166-21.507 c-18.003,4.949-30.682,16.751-30.682,30.539c0,17.593,20.824,26.857,35.853,33.708c8.711,3.97,18.68,3.97,27.392,0 c3.232-1.473,6.732-3.069,10.235-4.824C259.613,351.484,233.29,338.065,230.968,317.161z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogUserIcon);
export default __webpack_public_path__ + "static/media/dog-user-icon.6521aa49109d98dcbab5d99dc234ee81.svg";
export { ForwardRef as ReactComponent };